import Message from './src/main.js';
export default Message;



//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/packages/message/index.js
// module id = 1120
// module chunks = 11